import React from 'react';
import './BackgroundWatermark.css';

const BackgroundWatermark = () => {
  return (
    <div className="background-watermark" aria-hidden="true">
      <img 
        src="/assets/images/LandingAndBackgroundLogo.png" 
        alt=""
        className="watermark-logo"
      />
    </div>
  );
};

export default BackgroundWatermark;
